import { FilterFieldType, FilterFieldDef, FilterFieldValue } from '../../covance-filter';
import { of, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable()
export class CategoryDocumentsFilterStorage {

    public filterFields: Observable<FilterFieldValue[]>;
    private filterFieldDefs: FilterFieldDef[] = [
        {
            title: 'Posted',
            queryParam: 'postedDateTime',
            type: FilterFieldType.DateRange
        }
    ];

    constructor() {
        this.filterFields = this.getFilterDef();
    }

    private getFilterDef() {
        return of(this.filterFieldDefs.map(def => { return { def: def } as FilterFieldValue; }));
    }
}